// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  padding: 5rem 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

footer img {
  margin-left: 0.5rem;
}
footer a {
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: inherit;
}
code {
  background: #fafafa;
  border-radius: 5px;
  padding: 0.75rem;
  font-size: 1.1rem;
  font-family: Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono,
    Bitstream Vera Sans Mono, Courier New, monospace;
}
.input-labels-container input {
  width: 100%;
  height: 20px;
  border-style: solid;
  border-width: 4px;
  border-color: rgb(255, 94, 0);
  gap: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  border-style: none;
}

.input-labels-container select {
  width: 40px;
  height: 20px;
  border-style: solid;
  border-width: 4px;
  border-color: rgb(255, 94, 0);
  gap: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  border-style: none;
}

.upload-puzzle-content-container {
  flex: 1 1;
  padding: 10px;
  border-radius: 3px;
  /* max-width: 800px; */
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
}

.generate-newsie-from-text-container {
  background-color: rgb(255, 255, 255);
  padding: 20px;
  border-radius: 1%;
  border-color: rgba(28, 33, 39, 0.959);
  border-style: solid;
  border-width: 1px;
}
textarea {
  width: 100%;
  height: 200px;
  border: none;
}
.upload-puzzle-content-form-container {
  flex-direction: column;
  justify-content: center;
  background-color: rgba(31, 27, 250, 0.103);
  border-radius: 10px;
  padding: 20px;
  min-width: 50%;
  margin-left:auto;
  margin-right:auto;
}

.upload-puzzle-content-form-container h3 {
  margin: 0px;
}

@media (max-width: 700px) {
  .upload-puzzle-content-form-container {
    min-width: 75%;
  }
}

@media (max-width: 500px) {
  .upload-puzzle-content-form-container {
    min-width: 85%;
    height: 100%;
  }
}

.submit-puzzle-text-button {
  margin: auto;
  margin-top: 10px;
  padding: 10px;
  background-color: rgba(133, 160, 250, 0.493);
  border-radius: 5px;
  max-width: 200px;
}

.submit-puzzle-text-button.disabled {
  /* background-color: rgba(250, 170, 133, 0.493); */
  pointer-events: none;
  opacity: 0.5;
}

.content-text-label-container {
  display:flex;
}

.validation-warning-text {
  color: rgba(201, 88, 60, 0.76);
  font-weight: 900;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/CreateGames/CollectContentForm/CollectContentForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB;oDACkD;AACpD;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["main {\n  padding: 5rem 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nfooter img {\n  margin-left: 0.5rem;\n}\nfooter a {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n}\ncode {\n  background: #fafafa;\n  border-radius: 5px;\n  padding: 0.75rem;\n  font-size: 1.1rem;\n  font-family: Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono,\n    Bitstream Vera Sans Mono, Courier New, monospace;\n}\n.input-labels-container input {\n  width: 100%;\n  height: 20px;\n  border-style: solid;\n  border-width: 4px;\n  border-color: rgb(255, 94, 0);\n  gap: 5px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5px;\n  border-style: none;\n}\n\n.input-labels-container select {\n  width: 40px;\n  height: 20px;\n  border-style: solid;\n  border-width: 4px;\n  border-color: rgb(255, 94, 0);\n  gap: 5px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5px;\n  border-style: none;\n}\n\n.upload-puzzle-content-container {\n  flex: 1;\n  padding: 10px;\n  border-radius: 3px;\n  /* max-width: 800px; */\n  display: flex;\n  /* justify-content: center; */\n  flex-direction: column;\n}\n\n.generate-newsie-from-text-container {\n  background-color: rgb(255, 255, 255);\n  padding: 20px;\n  border-radius: 1%;\n  border-color: rgba(28, 33, 39, 0.959);\n  border-style: solid;\n  border-width: 1px;\n}\ntextarea {\n  width: 100%;\n  height: 200px;\n  border: none;\n}\n.upload-puzzle-content-form-container {\n  flex-direction: column;\n  justify-content: center;\n  background-color: rgba(31, 27, 250, 0.103);\n  border-radius: 10px;\n  padding: 20px;\n  min-width: 50%;\n  margin-left:auto;\n  margin-right:auto;\n}\n\n.upload-puzzle-content-form-container h3 {\n  margin: 0px;\n}\n\n@media (max-width: 700px) {\n  .upload-puzzle-content-form-container {\n    min-width: 75%;\n  }\n}\n\n@media (max-width: 500px) {\n  .upload-puzzle-content-form-container {\n    min-width: 85%;\n    height: 100%;\n  }\n}\n\n.submit-puzzle-text-button {\n  margin: auto;\n  margin-top: 10px;\n  padding: 10px;\n  background-color: rgba(133, 160, 250, 0.493);\n  border-radius: 5px;\n  max-width: 200px;\n}\n\n.submit-puzzle-text-button.disabled {\n  /* background-color: rgba(250, 170, 133, 0.493); */\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.content-text-label-container {\n  display:flex;\n}\n\n.validation-warning-text {\n  color: rgba(201, 88, 60, 0.76);\n  font-weight: 900;\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
